import DeclineButton from '../../../components/buttons/Decline_button.svg';
import DeclineDisabledButton from '../../../components/buttons/decline_disabled.svg';
import { EditIcon } from '../../buttons/EditIcon.tsx';
import { getRoomUnreadMsgCount } from '../../matrix/matrixFuntions.js';
import { getPatientVisiblePractices } from '../utils/patientPracticeUtils';

const AppointmentActions = ({ 
    appointment, 
    onDeleteClick, 
    onViewPracticesClick,
    onViewDetailsClick,
    onViewChat,
    isMobile = false,
    ChatButton,
    roomsNotificationCount
}) => {
    const isNewAppointment = appointment.patient_appointment_status.toUpperCase() === 'NEW';
    const isDeletedOrClosed = ['DELETED', 'CLOSED', 'DECLINED'].includes(
        appointment.patient_appointment_status.toUpperCase()
    );
    const visiblePractices = getPatientVisiblePractices(appointment);
    const hasSingleVisiblePractice = visiblePractices.length === 1;

    const ActionButton = ({ onClick, disabled, icon, alt, title, className = "", isSvg = false }) => (
        <button 
            onClick={onClick}
            disabled={disabled}
            className={`w-12 h-12 min-w-[48px] min-h-[48px] hover:bg-blue-50 rounded-lg transition-colors flex items-center justify-center ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
            title={title}
        >
            {isSvg ? (
                <EditIcon className="w-10 h-10 text-gray-600 transform -rotate-90" alt={alt} />
            ) : (
                <img src={icon} className="w-6 h-6" alt={alt} />
            )}
        </button>
    );

    const actions = (
        <div className={`gap-3 ${isMobile ? 'flex' : 'flex'}`}>
            {isNewAppointment ? (
                <>
                    {hasSingleVisiblePractice && (
                        <button
                            onClick={() => onViewChat(appointment, visiblePractices[0])}
                            className="p-2.5 hover:bg-blue-50 rounded-lg transition-colors"
                            title="Chat"
                        >
                            <img src={ChatButton} className="w-8 h-8" alt="Chat" />
                        </button>
                    )}
                    <ActionButton
                        onClick={() => onDeleteClick(appointment)}
                        icon={DeclineButton}
                        alt="Delete Appointment"
                        title="Delete Appointment"
                        className="hover:bg-red-50"
                    />
                    <ActionButton
                        onClick={() => onViewDetailsClick(appointment)}
                        isSvg={true}
                        alt="View Details"
                        title="View Details"
                    />
                </>
            ) : (
                <>
                    {!isDeletedOrClosed && hasSingleVisiblePractice && (
                        <div className="relative">
                            <button
                                onClick={() => onViewChat(appointment, visiblePractices[0])}
                                className="p-1 sm:p-3 min-w-[40px] sm:min-w-[48px] min-h-[40px] sm:min-h-[48px] hover:bg-blue-50 rounded-lg transition-colors flex items-center justify-center"
                                title="Chat"
                            >
                                <img src={ChatButton} className="w-8 h-8 sm:w-8 sm:h-8" alt="Chat" />
                            </button>
                            {/* Message count badge */}
                            {(() => {
                                const activePractice = visiblePractices[0];
                                console.log('Synapse Room ID:', activePractice?.synapse_room_id);
                                
                                const unreadCount = activePractice?.synapse_room_id 
                                    ? getRoomUnreadMsgCount(activePractice.synapse_room_id, roomsNotificationCount)
                                    : 0;
                                    
                                return unreadCount > 0 ? (
                                    <span className="absolute -top-1 -right-1 !bg-red-500 !text-white !text-xs !rounded-full !h-5 !w-5 !flex !items-center !justify-center !font-bold">
                                        {unreadCount > 99 ? '99+' : unreadCount}
                                    </span>
                                ) : null;
                            })()}
                        </div>
                    )}
                    <ActionButton
                        onClick={() => {}} // Disabled action
                        disabled
                        icon={DeclineDisabledButton}
                        alt="Delete Appointment"
                        title="Delete Appointment"
                    />
                    <ActionButton
                        onClick={() => onViewDetailsClick(appointment)}
                        isSvg={true}
                        alt="View Details"
                        title="View Details"
                        className="hover:bg-blue-50"
                    />
                </>
            )}
        </div>
    );

    return actions;
};

export default AppointmentActions;
